module.exports = __webpack_public_path__ + "img/summary_background_mobile.d41ddbe.webp";